export const WITHDRAWAL_DETAILS_TEST_ID = 'withdrawals-details-id';
